import { useTranslation } from 'react-i18next'

import { SubTitle, Text, Tittle } from '@/components/common/UI'
import { Icons } from '@/components/icons'
import { Card, CardBody, CardHeader } from '@/components/nextui'

export const Welcome = (): JSX.Element => {
    const { t } = useTranslation()

    return (
        <div className="flex flex-col items-center justify-center p-8 max-w-4xl mx-auto gap-8">
            <div className="text-6xl text-primary ">
                <Icons.UserGraduate />
            </div>
            <Tittle
                title={t('welcome.title')}
                className="text-center"
            />

            <p className="text-xl text-gray-600 text-center ">
                {t('welcome.subTitle')}
            </p>

            <Card className="w-full">
                <CardHeader className="pb-0">
                    <SubTitle
                        subTitle={t('welcome.initial')}
                        className="text-primary"
                    />
                </CardHeader>
                <CardBody>
                    <Text
                        text={t('welcome.description')}
                        className="text-gray-600"
                    />
                </CardBody>
            </Card>
        </div>
    )
}
